import Cascader from './src/cascader.vue'
import CascaderItem from './src/cascader-item.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToCascader: SFCWithInstall<typeof Cascader> = withInstall(Cascader)

export const ToCascaderItem: SFCWithInstall<typeof CascaderItem> = withInstall(CascaderItem)

export * from './src/instance'
